import { render, staticRenderFns } from "./PlatformConnect.vue?vue&type=template&id=00bd6622&"
import script from "./PlatformConnect.vue?vue&type=script&lang=js&"
export * from "./PlatformConnect.vue?vue&type=script&lang=js&"
import style0 from "./PlatformConnect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports